/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ComLapeyreCommerceControllersNewsletterRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { ComLapeyreCommerceControllersNewsletterResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * NewsletterApi - axios parameter creator
 * @export
 */
export const NewsletterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Push the email into SFMC Newsletter table.
         * @summary Newsletter
         * @param {string} storeId The store identifier.
         * @param {string} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
         * @param {ComLapeyreCommerceControllersNewsletterRequest} [comLapeyreCommerceControllersNewsletterRequest] The request object for newsletter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsletter: async (storeId: string, responseFormat?: string, comLapeyreCommerceControllersNewsletterRequest?: ComLapeyreCommerceControllersNewsletterRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('newsletter', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/resources/newsletter`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (responseFormat !== undefined) {
                localVarQueryParameter['responseFormat'] = responseFormat;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comLapeyreCommerceControllersNewsletterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsletterApi - functional programming interface
 * @export
 */
export const NewsletterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsletterApiAxiosParamCreator(configuration)
    return {
        /**
         * Push the email into SFMC Newsletter table.
         * @summary Newsletter
         * @param {string} storeId The store identifier.
         * @param {string} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
         * @param {ComLapeyreCommerceControllersNewsletterRequest} [comLapeyreCommerceControllersNewsletterRequest] The request object for newsletter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newsletter(storeId: string, responseFormat?: string, comLapeyreCommerceControllersNewsletterRequest?: ComLapeyreCommerceControllersNewsletterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComLapeyreCommerceControllersNewsletterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newsletter(storeId, responseFormat, comLapeyreCommerceControllersNewsletterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NewsletterApi - factory interface
 * @export
 */
export const NewsletterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsletterApiFp(configuration)
    return {
        /**
         * Push the email into SFMC Newsletter table.
         * @summary Newsletter
         * @param {string} storeId The store identifier.
         * @param {string} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
         * @param {ComLapeyreCommerceControllersNewsletterRequest} [comLapeyreCommerceControllersNewsletterRequest] The request object for newsletter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsletter(storeId: string, responseFormat?: string, comLapeyreCommerceControllersNewsletterRequest?: ComLapeyreCommerceControllersNewsletterRequest, options?: any): AxiosPromise<ComLapeyreCommerceControllersNewsletterResponse> {
            return localVarFp.newsletter(storeId, responseFormat, comLapeyreCommerceControllersNewsletterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsletterApi - object-oriented interface
 * @export
 * @class NewsletterApi
 * @extends {BaseAPI}
 */
export class NewsletterApi extends BaseAPI {
    /**
     * Push the email into SFMC Newsletter table.
     * @summary Newsletter
     * @param {string} storeId The store identifier.
     * @param {string} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
     * @param {ComLapeyreCommerceControllersNewsletterRequest} [comLapeyreCommerceControllersNewsletterRequest] The request object for newsletter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsletterApi
     */
    public newsletter(storeId: string, responseFormat?: string, comLapeyreCommerceControllersNewsletterRequest?: ComLapeyreCommerceControllersNewsletterRequest, options?: any) {
        return NewsletterApiFp(this.configuration).newsletter(storeId, responseFormat, comLapeyreCommerceControllersNewsletterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
